// extracted by mini-css-extract-plugin
export var heading = "style-module--heading--tY5bC";
export var left = "style-module--left--h0MAk";
export var link = "style-module--link--pbn78";
export var right = "style-module--right--0Z1QK";
export var root = "style-module--root--IqGqA";
export var title = "style-module--title--vHtDx";